import { useEffect } from "react";

let BASE_TITLE = "CRM";

export const setDocumentBase = (base) => { BASE_TITLE = base || "CRM"; if (!document.title || document.title === "CRM") document.title = BASE_TITLE; };

/**
 * Sets the document title (and optional meta description) for a page.
 * Restores the previous title on unmount.
 *
 * Usage:
 *   useDocumentTitle("Dashboard");
 *   useDocumentTitle("Members", "Manage learners, staff and admins");
 */
export default function useDocumentTitle(title, description, baseOverride) {
  useEffect(() => {
    const prevTitle = document.title;
    const base = baseOverride || BASE_TITLE;
    document.title = title ? `${title} · ${base}` : base;

    let prevDescription = null;
    let metaEl = null;
    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) {
        prevDescription = metaEl.getAttribute("content");
        metaEl.setAttribute("content", description);
      }
    }

    return () => {
      document.title = prevTitle;
      if (metaEl && prevDescription !== null) {
        metaEl.setAttribute("content", prevDescription);
      }
    };
  }, [title, description, baseOverride]);
}
